function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Sidebar");

var SvgSidebar = function SvgSidebar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M83.85,6.24H29.24a.79.79,0,0,0-.8.79V46.76H24.82a1.42,1.42,0,0,0-1.41,1.42v7.23a1.41,1.41,0,0,0,1.41,1.41h3.62V90.68a.79.79,0,0,0,.8.79H83.85a.79.79,0,0,0,.8-.79V7A.79.79,0,0,0,83.85,6.24ZM25.61,55.74a1.11,1.11,0,0,1-1.11-1.11V49a1.11,1.11,0,0,1,1.11-1.11h5.67A1.11,1.11,0,0,1,32.38,49v5.67a1.11,1.11,0,0,1-1.1,1.11H25.61Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidebar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SIDEBAR.3e2ae917.svg";
export { ForwardRef as ReactComponent };